export default __webpack_public_path__ + "static/media/firefly_logo.d1a6d87d.svg";